module.exports = __webpack_public_path__ + "media/images/ico-menu-close-f32982a5.svg";